import { render, staticRenderFns } from "./ManagerSelector.vue?vue&type=template&id=3d2d4670&scoped=true"
import script from "./ManagerSelector.vue?vue&type=script&lang=js"
export * from "./ManagerSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2d4670",
  null
  
)

export default component.exports